export const SURVEY_QUERY_PARAM_KROGER = 'k';
